import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaTimes, FaWrench, FaMoneyBillWave } from 'react-icons/fa';

const options = [
  { label: 'New Job Card', Icon: FaWrench, path: '/job-cards/list' },
  { label: 'New Expense', Icon: FaMoneyBillWave, path: '/expenses/new' },
];

export default function FloatingActionButton() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleOption = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <div className="lg:hidden">
      {isOpen && (
        <div
          data-testid="fab-backdrop"
          className="fixed inset-0 bg-black/20 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
        {isOpen && options.map(({ label, Icon, path }) => (
          <div key={path} className="flex items-center gap-3">
            <span className="bg-brand-secondary text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap shadow-md">
              {label}
            </span>
            <button
              aria-label={label}
              onClick={() => handleOption(path)}
              className="w-10 h-10 rounded-full bg-brand-primary text-white flex items-center justify-center shadow-lg hover:opacity-90 transition-opacity"
            >
              <Icon className="text-sm" />
            </button>
          </div>
        ))}
        <button
          aria-label={isOpen ? 'Close actions' : 'Open actions'}
          onClick={() => setIsOpen((o) => !o)}
          className="w-14 h-14 rounded-full bg-brand-primary text-white flex items-center justify-center shadow-xl hover:opacity-90 transition-all"
        >
          {isOpen
            ? <FaTimes className="text-lg" />
            : <FaPlus className="text-lg" />}
        </button>
      </div>
    </div>
  );
}
